import React, { useState, useEffect } from 'react';
import store from '@Store';
import { getOoxmlString, ooxmlStr } from '@Service/wordApiService';
import { DOCUMENT_MARKUP } from '@Constants/types';

let currentTab = '';

function callAPI() {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 1000);
    });
}

function useBackgroundService() {
    const [backgroundService, setBackgroundService] = useState(null);

    const pollDelay = 5000;

    useEffect(() => {
        const bgService = setInterval(() => {
            // eslint-disable-next-line
            callAPI().then(() => {
                const rootReducer = store.getState();
                const { document } = rootReducer;
                const { staleStatus, staleResult, markUpInProgress, isMarkupCancelling } = document;
                if (currentTab !== 'markup') {
                    // skip the ooxml fetching if we are not on the Markup tab
                    return;
                }

                if (markUpInProgress === 'Started') {
                    store.dispatch({
                        type: DOCUMENT_MARKUP.CHECK_STALE_STATUS,
                        payload: { staleStatus: '', staleResult: 'Good' }
                    });

                    return;
                }

                if (isMarkupCancelling === true) {
                    store.dispatch({
                        type: DOCUMENT_MARKUP.CHECK_STALE_STATUS,
                        payload: { staleStatus: '', staleResult: 'Good' }
                    });

                    return;
                }

                if (staleStatus === '') {
                    // check again...
                    store.dispatch({
                        type: DOCUMENT_MARKUP.CHECK_STALE_STATUS,
                        payload: { staleStatus: 'Checking', staleResult }
                    });
                    getOoxmlString();
                } else if (staleStatus === 'Checking') {
                    const ooxml = ooxmlStr();
                    if (ooxml === undefined || ooxml === null || ooxml === '') {
                        store.dispatch({
                            type: DOCUMENT_MARKUP.CHECK_STALE_STATUS,
                            payload: { staleStatus: '', staleResult: 'Stale' }
                        });
                    } else {
                        store.dispatch({
                            type: DOCUMENT_MARKUP.CHECK_STALE_STATUS,
                            payload: { staleStatus: '', staleResult: 'Good' }
                        });
                    }
                }
            });
        }, pollDelay);

        function cleanup() {
            clearInterval(bgService);
        }

        setBackgroundService(bgService);

        return cleanup;
    }, []);

    return backgroundService;
}

function CheckDocumentStateProcess(currentPage) {
    currentTab = currentPage.currentPage;

    useBackgroundService();

    return <></>;
}

export default CheckDocumentStateProcess;
